export default "__VITE_ASSET__D0XdvnV3__"